let api = {
    notificationList() {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .get('/dialogwatt/notification/')
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    notificationDetail(pk) {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .get(`/dialogwatt/notification/${pk}/`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    notificationDelete(pk) {
        return new Promise((resolve, reject) => {
            this.apiClient()
                .delete(`/dialogwatt/notification/${pk}/`)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.debug(error);
                    reject(error);
                });
        });
    },
    notificationSave(data) {
        let pk = data.pk;
        if (pk === null) {
            return new Promise((resolve, reject) => {
                this.apiClient()
                    .post(`/dialogwatt/notification/`, data)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.debug(error);
                        reject(error);
                    });
            });
        } else {
            return new Promise((resolve, reject) => {
                this.apiClient()
                    .patch(`/dialogwatt/notification/${pk}/`, data)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.debug(error);
                        reject(error);
                    });
            });
        }
    },
};

export default api;
